import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../elements/button';
import './hero.scss';
import IconChevronBigDown from '../../../images/icon-chevron-big-down.svg';
import IconDots from '../../../images/icon-dots.svg';
import dataHero from './dataHero.json';
import Lottie from 'lottie-react-web';
import { Link } from 'gatsby';

import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css/animate.css';
const Hero = (props) => {
	let textBody = (
		<div className='text-body'>
			<p>
				Die Software von Sustragil unterstützt die Chemieindustrie bei dem
				Austausch und der Verwendung produktsicherheitsspezifischer
				Informationen entlang der Lieferkette.
			</p>
			<div className='buttons'>
				<Button
					text='Demo anfordern'
					variant='primary'
					openModal={props.openModal}
				/>
				<Link to='#flowchart'>
					<Button text='Mehr' variant='quartery' chevron />
				</Link>
			</div>
		</div>
	);
	useEffect(() => {
		const script = document.createElement('script');

		script.src =
			'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js';
		script.async = true;

		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		};
	}, []);
	return (
		<section id='hero'>
			<Container>
				<Row>
					<Col className='col-text order-md-2' md={6}>
						<div className='text-block'>
							<div>
								<h1>
									Ihr digitaler Assistent
									<span className='add-whitespace d-sm-none'>
										in der Produktsicherheit
									</span>
									<span className='d-none d-sm-inline-block'>
										in der Produktsicherheit
									</span>
								</h1>
							</div>
							<div className='d-none d-md-block'>{textBody}</div>
						</div>
					</Col>
					<Col md={6} className='col-animation'>
						<div className='lottie'>
							<lottie-player
								src='https://assets7.lottiefiles.com/private_files/lf30_1pobvwwu.json'
								background='transparent'
								speed='0.5'
								className='lottie-player'
								loop
								autoplay
							></lottie-player>
						</div>
						<div className='d-block d-md-none'>{textBody}</div>
					</Col>
				</Row>
				<div className='arrow-down'>
					<img src={IconChevronBigDown} alt='' />
				</div>
			</Container>
		</section>
	);
};

export default Hero;
